import { AssetData } from "../types/asset-types.types";

export const DUMMY_ASSET_DATA: Array<{ data: AssetData }> = [
  {
    data: {
      assetName: "H",
      activationDate: "2024-02-15",
      status: "active",
      installation:
        "<div><b>Installation Instructions: </b></div></br><div>1. Download the installer from the link provided in your ITMP order completion.</div><div>2. Install the software and activate with the license key provided in your ITMP order completion.</div><div>3. If you need admin rights please visit https://it.amazon.com/en/help/articles/local-admin-rights</div>",
    },
  },
  {
    data: {
      assetName: "B",
      activationDate: "2024-01-20",
      status: "active",
    },
  },
  {
    data: {
      assetName: "A",
      activationDate: "2024-03-01",
      status: "active",
    },
  },
  {
    data: {
      assetName: "Z",
      activationDate: "2024-02-28",
      status: "active",
    },
  },
  {
    data: {
      assetName: "C",
      activationDate: "2024-03-15",
      status: "active",
      installation: "intsllation",
    },
  },
];
